import { __makeTemplateObject } from '../../_virtual/_tslib.js';
import styled from 'styled-components';
import * as typography from '@tapas/typography';
import { ButtonSizesEnum, ButtonStyleTypeEnum } from '../types.js';
import { MediumButtonStyle, XSmallButtonStyle, SmallButtonStyle, LargeButtonStyle, XLargeButtonStyle, FullWidthButtonStyle } from './size.js';
import { SecondaryButtonStyle, PillButtonStyle, LinkButtonStyle, OutlineButtonStyle, GhostButtonStyle, DangerButtonStyle, PrimaryButtonStyle, AnchorStyle } from './styleType.js';

var getLoadingSpinnerColor = function (theme) { return ({
    primary: theme.colorTokens.accent.onDisabled,
    secondary: '',
    danger: theme.colorTokens.accent.onDisabled,
    outline: theme.colorTokens.neutralButton.disabled,
    link: '',
    ghost: '',
    pill: '',
}); };
var LoadingSpinnerWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-right: ", ";\n  ", ";\n\n  svg {\n    path {\n      stroke: ", ";\n    }\n  }\n"], ["\n  margin-right: ", ";\n  ", ";\n\n  svg {\n    path {\n      stroke: ", ";\n    }\n  }\n"])), function (_a) {
    var buttonSize = _a.buttonSize;
    return buttonSize !== 'small' && buttonSize !== 'x-small' ? '0.8rem' : '0';
}, function (_a) {
    var buttonSize = _a.buttonSize;
    return buttonSize === 'x-large'
        ? "\n    width: 2.4rem;\n    height: 2.4rem;\n  "
        : "\n    width: 1.6rem;\n    height: 1.6rem;\n  ";
}, function (_a) {
    var buttonStyleType = _a.buttonStyleType, theme = _a.theme;
    return getLoadingSpinnerColor(theme)[buttonStyleType];
});
var StyledButton = styled.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0;\n\n  border: 0;\n  border-radius: 8px;\n  box-sizing: border-box;\n\n  outline: none;\n\n  text-align: center;\n\n  cursor: pointer;\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n\n  ", "\n\n  &.disabled {\n    pointer-events: none;\n  }\n\n  ", "\n\n  ", "\n    \n  ", "\n\n  ", "\n"], ["\n  ", "\n\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  padding: 0;\n\n  border: 0;\n  border-radius: 8px;\n  box-sizing: border-box;\n\n  outline: none;\n\n  text-align: center;\n\n  cursor: pointer;\n\n  &:disabled {\n    cursor: not-allowed;\n  }\n\n  ", "\n\n  &.disabled {\n    pointer-events: none;\n  }\n\n  ", "\n\n  ", "\n    \n  ", "\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return typography.body(theme.fonts.default, 1.4, 700);
}, function (_a) {
    var disabled = _a.disabled, href = _a.href;
    return disabled && href && "pointer-events: none;";
}, function (_a) {
    var size = _a.size;
    switch (size) {
        case ButtonSizesEnum.xlarge:
            return XLargeButtonStyle;
        case ButtonSizesEnum.large:
            return LargeButtonStyle;
        case ButtonSizesEnum.small:
            return SmallButtonStyle;
        case ButtonSizesEnum.xsmall:
            return XSmallButtonStyle;
        case ButtonSizesEnum.medium:
        default:
            return MediumButtonStyle;
    }
}, function (_a) {
    var fullwidth = _a.fullwidth;
    return fullwidth !== 'none' && FullWidthButtonStyle;
}, function (_a) {
    var styleType = _a.styleType;
    switch (styleType) {
        case ButtonStyleTypeEnum.primary:
            return PrimaryButtonStyle;
        case ButtonStyleTypeEnum.danger:
            return DangerButtonStyle;
        case ButtonStyleTypeEnum.ghost:
            return GhostButtonStyle;
        case ButtonStyleTypeEnum.outline:
            return OutlineButtonStyle;
        case ButtonStyleTypeEnum.link:
            return LinkButtonStyle;
        case ButtonStyleTypeEnum.pill:
            return PillButtonStyle;
        case ButtonStyleTypeEnum.secondary:
        default:
            return SecondaryButtonStyle;
    }
}, function (_a) {
    var href = _a.href;
    return href && AnchorStyle;
});
var templateObject_1, templateObject_2;

export { LoadingSpinnerWrapper, StyledButton };
